module.exports = __webpack_public_path__ + "img/img_bg.0eae88d6.png";